var React = require('react');

function ArrowSharpDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .sharp-arrow {\n        fill: #262626;\n      }\n    ")),React.createElement("g",{"id":"bfd6f6d2-4a70-4c35-87cc-06d4dc0a67ea","data-name":"Group 928","key":1},React.createElement("g",{"id":"a28fd2c2-5923-4987-a3b3-4e8b34445b88","data-name":"Path 219"},React.createElement("polygon",{"className":"sharp-arrow","points":"21.7 15.42 10.85 26.27 0 15.42 1.77 13.65 9.6 21.49 9.6 0 12.1 0 12.1 21.49 19.94 13.65 21.7 15.42"})))]);
}

ArrowSharpDown.defaultProps = {"id":"a29fe96a-c4bc-4228-baf1-7c3c3d4b34eb","data-name":"sharp-arrow","viewBox":"0 0 21.70001 26.27002"};

module.exports = ArrowSharpDown;

ArrowSharpDown.default = ArrowSharpDown;
